import React from 'react'
import PropTypes from 'prop-types'
import { Joyride } from 'react-joyride'

const NewUserTour = props => {
  const steps = [
    {
      target: '#home-link',
      content: 'Click the logo to return to the dashboard.',
      disableBeacon: true,
      placement: 'auto',
      offset: 5
    },
    {
      target: '#goals-link',
      content: 'Click this to open your goals.',
      disableBeacon: true,
      placement: 'bottom',
      offset: 5
    },
    {
      target: '#menu-link',
      content: 'Click this menu to access your profile and settings.',
      disableBeacon: true,
      placement: 'bottom',
      offset: 5
    }
  ]

  const joyrideStateChanged = (s) => {
    if (s.status === 'finished' || s.action === 'close') { props.tourActions.setShowTour(false) }
  }

  return (
    <Joyride
      continuous steps={steps} spotlightPadding={5} spotlightClicks callback={joyrideStateChanged}
      run={props.tourActions.showTour() === 'NewUserTour'} disableOverlay
    />
  )
}

NewUserTour.propTypes = {
  tourActions: PropTypes.object.isRequired
}

export default NewUserTour
